<template>
  <div class="mt-3">
    <div v-if="loading" class="text-gray-500 text-sm p-2">Loading engagements…</div>
    <div v-else-if="!engagements.length" class="text-gray-500 text-sm p-2">
      No engagements for this client.
    </div>
    <table v-else class="w-full text-sm">
      <thead>
        <tr class="bg-dark-primary text-white text-left">
          <th class="p-2">ID</th>
          <th class="p-2">Title</th>
          <th class="p-2">Start</th>
          <th class="p-2">End</th>
          <th class="p-2 text-right">Retainer</th>
          <th class="p-2">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="eng in engagements" :key="eng.id" class="border-t border-gray-200 hover:bg-gray-50">
          <td class="p-2 whitespace-nowrap text-gray-500">#{{ eng.id }}</td>
          <td class="p-2">{{ eng.title || eng.invoice_label || '—' }}</td>
          <td class="p-2 whitespace-nowrap">{{ eng.start_date || '—' }}</td>
          <td class="p-2 whitespace-nowrap">{{ eng.end_date || '—' }}</td>
          <td class="p-2 text-right whitespace-nowrap">{{ eng.retainer_amount != null ? `$${eng.retainer_amount}` : '—' }}</td>
          <td class="p-2">
            <span v-if="eng.is_paused" class="px-1.5 py-0.5 rounded bg-yellow-200 text-yellow-900 text-[10px] font-semibold uppercase tracking-wide">On Hold</span>
            <span v-else-if="eng.end_date && eng.end_date < today" class="px-1.5 py-0.5 rounded bg-gray-200 text-gray-700 text-[10px] font-semibold uppercase tracking-wide">Ended</span>
            <span v-else class="px-1.5 py-0.5 rounded bg-green-100 text-green-800 text-[10px] font-semibold uppercase tracking-wide">Active</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default { name: 'client-engagements' };
</script>

<script setup>
import { ref, defineProps, watch, onMounted } from 'vue';
import { useStore } from 'vuex';
import { getEngagements } from '@/services/Engagement.js';

const props = defineProps(['client']);
const store = useStore();

const engagements = ref([]);
const loading = ref(false);
const today = new Date().toISOString().slice(0, 10);

async function load() {
  const clientId = props.client && props.client.id;
  if (!clientId) { engagements.value = []; return; }
  loading.value = true;
  try {
    // No status filter: show ALL engagements for this client (active, paused,
    // ended, non-invoicing). page_size large so they all come back at once.
    const result = await getEngagements(store.state.auth.token, `?client=${clientId}&page_size=500`);
    engagements.value = (result && result.results) || [];
  } catch (err) {
    engagements.value = [];
  } finally {
    loading.value = false;
  }
}

onMounted(load);
watch(() => props.client && props.client.id, load);
</script>
